var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLynxActivitiesLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lynx-activities-logo_svg__uuid-2fd8d163-52a9-46a6-a6c3-e60d2a073f0e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330 327.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lynx-activities-logo_svg__uuid-6360e4a2-4147-4d7f-998a-5ce703bed5b8{fill:none}.lynx-activities-logo_svg__uuid-300b4b2f-bb98-4b8d-806d-26f3f2a5fe1c{fill:url(#lynx-activities-logo_svg__uuid-dc5bc9f7-e781-4519-9d3f-b9fc68bf244c)}.lynx-activities-logo_svg__uuid-e319d54d-fdf4-4328-8230-0f4d709bbfe5{fill:url(#lynx-activities-logo_svg__uuid-b54c3695-7ed9-493f-97e1-5ada862e4182)}.lynx-activities-logo_svg__uuid-cf5165d9-f09f-4271-b5c2-135c9855a712{fill:url(#lynx-activities-logo_svg__uuid-a5739738-cc9d-4998-94bc-fd317a2ae4bc)}.lynx-activities-logo_svg__uuid-bd8fe5b2-a4f3-4855-a0d0-dc4bad90a679{fill:url(#lynx-activities-logo_svg__uuid-9f28a532-90c3-4c09-811b-02de96db406b)}.lynx-activities-logo_svg__uuid-7c9ea91c-de6d-4d1d-b48b-4a4cb49a12bf{fill:url(#lynx-activities-logo_svg__uuid-946ec2af-ff06-4fbe-8020-f53c9c0cb5d1)}.lynx-activities-logo_svg__uuid-fd1c3d9c-ba07-43f3-b120-ab1f20e6200a{fill:#ff83ed}.lynx-activities-logo_svg__uuid-b6032d9d-3432-4792-a3f6-5e0ef50c502a{fill:#c43dd9}.lynx-activities-logo_svg__uuid-aec914aa-e709-47dd-82a7-d47f7f88ec99{fill:url(#lynx-activities-logo_svg__uuid-5a3d8feb-3b96-4cc6-8da5-cbaea5bdd167)}.lynx-activities-logo_svg__uuid-6dac5ca2-4738-4d25-bd11-571b082c49f0{fill:url(#lynx-activities-logo_svg__uuid-f7de7310-5d25-4bdc-9039-16879e634979)}.lynx-activities-logo_svg__uuid-cf7a02a2-f89d-420f-852c-1b8f30985260{fill:url(#lynx-activities-logo_svg__uuid-5d949384-c3ec-4a39-9430-69c8306bbc41)}.lynx-activities-logo_svg__uuid-881fd1fc-8d84-4e61-93b9-d545ea093a0b{fill:url(#lynx-activities-logo_svg__uuid-7cf4fa92-332a-4ad4-9f92-6c17946d4dbf)}.lynx-activities-logo_svg__uuid-4209033a-be10-4a6a-91a7-f07d3e49e645{fill:url(#lynx-activities-logo_svg__uuid-c1bfddaf-dcf9-4ba6-9f54-e1f956588295)}.lynx-activities-logo_svg__uuid-62eb0124-cbc7-4979-a3a3-74fa3b61a26d{fill:#38004f;isolation:isolate;opacity:.1}.lynx-activities-logo_svg__uuid-d6758901-0bad-4a4c-91ca-d16e19ccd257{fill:url(#lynx-activities-logo_svg__uuid-8ca8e1f0-5eb8-40d4-be5c-58b63adc033e)}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-946ec2af-ff06-4fbe-8020-f53c9c0cb5d1",
    x1: 89.15,
    y1: -2.72,
    x2: 208.66,
    y2: 87.33,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-9f28a532-90c3-4c09-811b-02de96db406b",
    x1: 153.01,
    y1: 206.57,
    x2: 280.01,
    y2: 302.27,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c38f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11bdd8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-a5739738-cc9d-4998-94bc-fd317a2ae4bc",
    x1: 35.06,
    y1: 180.51,
    x2: 209.31,
    y2: 311.82,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f410ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-7cf4fa92-332a-4ad4-9f92-6c17946d4dbf",
    x1: -6.68,
    y1: 92.03,
    x2: 268.23,
    y2: 299.19,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2374d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f410ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-c1bfddaf-dcf9-4ba6-9f54-e1f956588295",
    x1: 89.41,
    y1: -3.05,
    x2: 208.91,
    y2: 87,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-5a3d8feb-3b96-4cc6-8da5-cbaea5bdd167",
    x1: 171.55,
    y1: 275.97,
    x2: 318.78,
    y2: 275.97,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45e4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-8ca8e1f0-5eb8-40d4-be5c-58b63adc033e",
    x1: 211.88,
    y1: 88.77,
    x2: 344.36,
    y2: 188.61,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#148c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11f2df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-dc5bc9f7-e781-4519-9d3f-b9fc68bf244c",
    x1: 306.73,
    y1: 141.77,
    x2: 357.05,
    y2: 179.68,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f410ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-b54c3695-7ed9-493f-97e1-5ada862e4182",
    x1: 163.45,
    y1: 86.69,
    x2: 252.12,
    y2: 86.69,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-f7de7310-5d25-4bdc-9039-16879e634979",
    x1: 194.96,
    y1: 184.61,
    x2: 324.27,
    y2: 184.61,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80ffc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82ffe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-activities-logo_svg__uuid-5d949384-c3ec-4a39-9430-69c8306bbc41",
    x1: 67.87,
    y1: 171.35,
    x2: 149.28,
    y2: 171.35,
    gradientTransform: "translate(0 328.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff789f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff59f1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-7c9ea91c-de6d-4d1d-b48b-4a4cb49a12bf",
    d: "m249.96,299.78c-20.75-28.56-67.99-93.58-84.67-116.54-21.77,29.97-70.77,97.4-79.53,109.47,48.33,31.6,113.36,34.19,164.21,7.07h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-6360e4a2-4147-4d7f-998a-5ce703bed5b8",
    d: "m154.06,137.74V.35c-.14,0-.27.02-.41.03v137.23l.41.13h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-6360e4a2-4147-4d7f-998a-5ce703bed5b8",
    d: "m322.71,123.13c-.03-.11-.05-.22-.08-.33l-129.12,41.95.21.29,128.99-41.91h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-6360e4a2-4147-4d7f-998a-5ce703bed5b8",
    d: "m147.28,169.29l-79.81,109.85c.12.1.24.2.36.31l80.12-110.28L12.58,125.19c-.02.11-.04.22-.06.32l134.75,43.79h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-6360e4a2-4147-4d7f-998a-5ce703bed5b8",
    d: "m249.96,299.78c.1-.06.21-.11.32-.16-16.95-23.34-67.34-92.68-84.77-116.68-.07.1-.14.2-.22.3,16.68,22.96,63.93,87.98,84.67,116.54h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-bd8fe5b2-a4f3-4855-a0d0-dc4bad90a679",
    d: "m314.23,98.6C291.46,46.45,242.34,8.38,183.78,1.28c-3.15-.38-6.32-.69-9.52-.89v149.3l142.02-46.15c-.66-1.66-1.34-3.31-2.06-4.95h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-cf5165d9-f09f-4271-b5c2-135c9855a712",
    d: "m56.06,40.73c-17.34,15.1-31.58,33.76-41.08,54.88-1.19,2.61-2.34,5.25-3.39,7.92l142.07,46.16V.38c-36.04,1.95-70.58,16.82-97.59,40.35h-.01Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-881fd1fc-8d84-4e61-93b9-d545ea093a0b",
    d: "m12.53,125.51l-7.36-2.39c-13.82,52.37.6,110.82,37.19,150.72,5.3,5.84,11,11.32,17.08,16.36l8.03-11.06,79.81-109.85L12.53,125.5h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-4209033a-be10-4a6a-91a7-f07d3e49e645",
    d: "m85.76,292.7c8.76-12.06,57.76-79.5,79.53-109.47-.47-.64-.91-1.26-1.33-1.83-11.27,15.51-69.5,95.66-87.84,120.9,50.06,32.54,117.91,34.08,169.38,3.8,2.13-1.22,4.24-2.47,6.29-3.82-.58-.8-1.19-1.64-1.83-2.51-50.84,27.12-115.88,24.53-164.21-7.07h0Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-b6032d9d-3432-4792-a3f6-5e0ef50c502a",
    d: "m55.69,40.44C80.98,18.03,113.38,3.44,147.1.45l6.74-.45c.14,0,.25.09.26.23,0,.15-.1.25-.24.27-26.06,6.13-50.89,14.52-74.45,27.14-7.81,4.12-15.47,8.62-23.4,13.18-.12.09-.31.08-.38-.07-.06-.11-.04-.24.05-.31h0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-aec914aa-e709-47dd-82a7-d47f7f88ec99",
    d: "m174.07.03l5.79.53c1.93.18,3.86.31,5.77.65l5.75.88,2.87.44c.95.18,1.89.41,2.84.61l5.68,1.26c.94.22,1.9.39,2.83.66l2.79.82,5.58,1.64,1.4.41c.46.15.91.33,1.37.49l2.73,1c14.59,5.24,28.44,12.57,41,21.67.78.57,1.6,1.1,2.36,1.7l2.26,1.83,4.52,3.66,1.13.92,1.07.99,2.14,1.97,4.28,3.94c1.37,1.37,2.69,2.8,4.04,4.19,1.32,1.42,2.71,2.77,3.98,4.24l3.74,4.45c1.23,1.5,2.55,2.93,3.65,4.52l3.45,4.68,1.72,2.34,1.57,2.45c2.07,3.27,4.28,6.47,6.07,9.91l2.82,5.08c.93,1.7,1.69,3.49,2.54,5.23l2.48,5.26,2.22,5.37c.05.13,0,.27-.14.32-.12.05-.25,0-.31-.11l-.02-.03-2.81-5.1-2.96-4.98c-1.02-1.64-1.88-3.35-2.94-4.95l-3.18-4.79c-1.98-3.26-4.34-6.28-6.58-9.35l-1.68-2.3-1.8-2.21-3.58-4.42c-1.15-1.51-2.5-2.84-3.77-4.25-1.28-1.39-2.52-2.82-3.78-4.22-1.28-1.39-2.67-2.67-4-4.01-1.35-1.32-2.67-2.67-4.04-3.96-2.88-2.44-5.56-5.09-8.48-7.47l-4.43-3.5-2.21-1.75c-.74-.58-1.54-1.08-2.31-1.62-3.09-2.15-6.04-4.5-9.3-6.4l-4.79-2.99c-.79-.52-1.62-.97-2.45-1.4-.83-.44-1.65-.9-2.47-1.36l-4.93-2.77-5.1-2.45c-1.71-.8-3.39-1.67-5.13-2.41l-5.23-2.2-2.62-1.1c-.44-.18-.87-.38-1.32-.54l-1.34-.46c-1.79-.62-3.59-1.22-5.37-1.89l-2.69-.98c-.9-.32-1.82-.54-2.73-.82l-5.5-1.6c-.92-.27-1.83-.58-2.75-.83l-2.79-.66c-1.86-.44-3.74-.86-5.6-1.35-1.86-.52-3.76-.82-5.66-1.19l-5.71-1.18h-.04c-.13-.04-.22-.17-.19-.3.03-.12.14-.21.27-.2h.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-62eb0124-cbc7-4979-a3a3-74fa3b61a26d",
    d: "m294.46,171.35l42.13,24.32c4.9,2.83,11.03-.71,11.03-6.37v-48.64c0-5.66-6.13-9.2-11.03-6.37l-42.13,24.32c-4.9,2.83-4.9,9.91,0,12.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-d6758901-0bad-4a4c-91ca-d16e19ccd257",
    d: "m290.46,179.01c-5.43-3.14-8.68-8.76-8.68-15.03s3.24-11.89,8.68-15.03l33.73-19.48c-.45-2.12-.94-4.24-1.48-6.34l-128.99,41.91,84.33,116.07-84.33-116.07-13.08,4.25,87.83,120.89c4.48-3.69,8.74-7.62,12.78-11.76h0c21.4-21.96,36.43-49.97,42.95-79.93l-33.74-19.48Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-300b4b2f-bb98-4b8d-806d-26f3f2a5fe1c",
    d: "m295.46,170.35l42.13,24.32c4.9,2.83,11.03-.71,11.03-6.37v-48.64c0-5.66-6.13-9.2-11.03-6.37l-42.13,24.32c-4.9,2.83-4.9,9.91,0,12.74Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-fd1c3d9c-ba07-43f3-b120-ab1f20e6200a",
    d: "m348.52,188.3c-1.15-15.95-1.48-33.19-1.7-49.15-.23-3.7-4.58-6.21-7.9-4.56-1.63.8-4.35,2.47-6.01,3.37-7.12,4-17.47,9.54-24.79,13.41-4.21,2.1-8.36,4.31-12.62,6.32l-.1-.17,24.37-14.13c4.34-2.43,14.08-8.27,18.32-10.57,4.5-2.3,10.41,1.11,10.66,6.16.09,2.38.02,4.7.03,7.06-.01,8.98-.06,32.99-.07,42.26h-.2.01Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-e319d54d-fdf4-4328-8230-0f4d709bbfe5",
    d: "m249.96,299.75c-8.2-8.88-15.86-18.16-23.32-27.58-3.78-4.67-7.36-9.49-11.04-14.23l-10.73-14.46c-3.47-4.89-6.99-9.76-10.43-14.68-3.38-4.96-6.85-9.86-10.13-14.9-6.65-10.01-13.11-20.15-19.03-30.69v-.02c-.07-.1-.03-.22.06-.27s.2-.02.26.06l42.5,58.15,42.18,58.39c.06.09.04.21-.04.28-.08.06-.2.05-.26-.03l-.02-.02h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-6dac5ca2-4738-4d25-bd11-571b082c49f0",
    d: "m322.76,123.28c-10.22,4.33-20.55,8.27-30.95,12.03-5.18,1.93-10.42,3.68-15.63,5.53l-15.72,5.25-15.81,4.99c-5.3,1.57-10.57,3.23-15.9,4.7-10.63,3.03-21.33,5.91-32.2,8.15h-.01c-.08.02-.17-.03-.18-.12-.02-.08.03-.16.11-.18,10.54-3.32,21.04-6.76,31.54-10.18l31.5-10.32,31.55-10.16c10.52-3.37,21.05-6.74,31.61-9.99.08-.03.17.02.19.1s-.02.16-.09.19h-.02.01Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-cf7a02a2-f89d-420f-852c-1b8f30985260",
    d: "m147.22,169.47c-6.89-.75-13.57-2.14-20.17-3.77-3.32-.75-6.57-1.74-9.85-2.61-3.26-.96-6.49-1.98-9.73-2.97-3.21-1.11-6.43-2.17-9.62-3.32-3.17-1.22-6.37-2.34-9.5-3.68-6.3-2.57-12.52-5.37-18.54-8.8l-.03-.02c-.09-.05-.13-.18-.07-.27.05-.08.15-.12.23-.09l38.77,12.39,38.65,12.77c.1.03.16.15.13.25-.03.09-.12.14-.21.13h-.06Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-b6032d9d-3432-4792-a3f6-5e0ef50c502a",
    d: "m153.41,137.61c-3.38-22.79-4.13-45.67-4.25-68.62.13-22.96.89-45.85,4.25-68.65.02-.14.15-.23.28-.21.12.02.21.12.21.24.24,31.39.28,71.4.17,102.92,0,8.53-.09,25.78-.17,34.31,0,.14-.11.25-.25.25s-.24-.11-.25-.25h0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-62eb0124-cbc7-4979-a3a3-74fa3b61a26d",
    d: "m33.72,64.46c-7.4,9.6-13.74,20.04-18.75,31.17-1.19,2.61-2.34,5.25-3.39,7.92l6.75,2.19c3.38-14.55,8.59-28.39,15.38-41.29h.01Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-62eb0124-cbc7-4979-a3a3-74fa3b61a26d",
    d: "m59.78,290.2l7.69-10.58,3.79-5.22c-35.25-31.73-57.42-77.71-57.42-128.87,0-6.35.36-12.61,1.02-18.78l-2.34-.76-7.36-2.39C1.73,136.6.05,149.98,0,163.35c.12,51.02,23.35,96.61,59.78,126.86h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-activities-logo_svg__uuid-62eb0124-cbc7-4979-a3a3-74fa3b61a26d",
    d: "m234.98,311.75c-15.18,4.34-31.21,6.68-47.79,6.68-37.16,0-71.59-11.7-99.81-31.61-4.36,6-8.11,11.17-10.96,15.09,25.19,16.1,55.04,25.55,87.07,25.9,24.63.08,49.28-5.24,71.5-16.06h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynxActivitiesLogo);
export default __webpack_public_path__ + "static/media/lynx-activities-logo.ea659ce1f86f8531cdd83c79cb3baded.svg";
export { ForwardRef as ReactComponent };